import type {PerkIntegrationSpec, PerkIntegrationStruct} from '@cohort/shared/schema/apps/app';
import {EmailSchema} from '@cohort/shared/schema/common';
import {z} from 'zod';

export const PrestashopGroupConfigSchema = z.object({
  loginUrl: z.string().url(),
  registrationUrl: z.string().url(),
});
export type PrestashopGroupConfig = z.infer<typeof PrestashopGroupConfigSchema>;

export const PrestashopGroupStateSchema = z.object({
  groupId: z.number(),
});
export type PrestashopGroupState = z.infer<typeof PrestashopGroupStateSchema>;

export const PrestashopGroupAccessDataSchema = z.object({});
export type PrestashopGroupAccessData = z.infer<typeof PrestashopGroupAccessDataSchema>;

export const PrestashopGroupUsageInputSchema = z.object({
  email: EmailSchema,
});
export type PrestashopGroupUsageInput = z.infer<typeof PrestashopGroupUsageInputSchema>;

export const PrestashopGroupUsageDataSchema = z.object({
  prestashopCustomerId: z.number().nullable(),
  prestashopCustomerEmail: z.string().nullable(),
});
export type PrestashopGroupUsageData = z.infer<typeof PrestashopGroupUsageDataSchema>;

export type PrestashopGroupStruct = PerkIntegrationStruct<
  'prestashop.group',
  PrestashopGroupConfig,
  PrestashopGroupState,
  PrestashopGroupAccessData,
  PrestashopGroupUsageInput,
  PrestashopGroupUsageData
>;

export const PrestashopGroupPerkIntegrationSpec: PerkIntegrationSpec<PrestashopGroupStruct> = {
  id: 'prestashop.group' as const,
  configSchema: PrestashopGroupConfigSchema,
  stateSchema: PrestashopGroupStateSchema,
  accessDataSchema: PrestashopGroupAccessDataSchema,
  usageInputDataSchema: PrestashopGroupUsageInputSchema,
  internalUsageDataSchema: PrestashopGroupUsageDataSchema,
  exposedUsageDataSchema: PrestashopGroupUsageDataSchema,
  defaultMaxUsagesPerToken: null,
};
